import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconClose } from "blocks-nextjs/blocks-react/components/Icons/Close/Close";
import { CatIconWarningTriangleFilled } from "blocks-nextjs/blocks-react/components/Icons/WarningTriangleFilled/WarningTriangleFilled";
import React from "react";
import { useUpdateOrDeactivateChargerLink } from "../../services/query/eflow-charge-operation-planner-api.query";
import useGlobalStore from "../../store/useGlobalStore";
import { ChargerAssetLinkUpdateRequest } from "../../swagger/eFlowService-v1/models/ChargerAssetLinkUpdateRequest";
import { Variant } from "../GlobalNotification/GlobalNotification";
const DeactivateLinkModal = ({ deactivatingLinkData, isOpen, onClose, onConfirm }) => {
    if (!isOpen)
        return null;
    const { mutate: updateOrDeactivateLinkMutate } = useUpdateOrDeactivateChargerLink();
    const { setGlobalNotification, userPartyNumber } = useGlobalStore((state) => ({
        setGlobalNotification: state.setGlobalNotification,
        userPartyNumber: state.userPartyNumber
    }));
    const getUpdateOrDeactivateMutateParam = () => {
        return {
            onError: () => {
                const errorMessage = "Failed to Deactivate the link";
                setGlobalNotification({
                    message: `${errorMessage}.`,
                    showNotification: true,
                    type: Variant.error
                });
                onClose();
            },
            onSuccess: () => {
                const successMessage = "Link deactivated successfully.";
                setGlobalNotification({
                    message: `${successMessage}.`,
                    showNotification: true,
                    type: Variant.success
                });
                onConfirm();
            }
        };
    };
    const handleDeactivateLink = () => {
        if (deactivatingLinkData) {
            const chargerAssetLinkUpdateRequest = {
                link: deactivatingLinkData.link,
                partyNumber: userPartyNumber || "",
                status: ChargerAssetLinkUpdateRequest.status.DEACTIVATED
            };
            updateOrDeactivateLinkMutate(chargerAssetLinkUpdateRequest, getUpdateOrDeactivateMutateParam());
        }
    };
    return (_jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50", children: _jsxs("div", { className: "bg-white rounded-lg shadow-xl w-full max-w-lg mx-4 overflow-hidden", children: [_jsxs("div", { className: "flex justify-between items-start p-6 pb-2", children: [_jsx(CatHeading, { variant: "title-sm", children: "Do you want to deactivate the link?" }), _jsx("button", { className: "text-gray-500 hover:text-gray-700", "data-test": "deactivate-link-modal-close-button", onClick: onClose, children: _jsx(CatIconClose, {}) })] }), _jsxs("div", { className: "p-6 pt-2", children: [_jsxs("p", { className: "text-gray-600 mb-8", children: ["Are you sure you want to delete this generated link?", _jsx("br", {}), "This action cannot be undone."] }), _jsxs("div", { className: "flex items-center gap-4", children: [_jsxs("button", { className: "bg-[#D03027] text-white hover:bg-[#B02017] flex items-center gap-2 px-4 py-2 rounded font-medium transition-colors", "data-test": "deactivate-link-confirm-button", onClick: handleDeactivateLink, children: [_jsx(CatIconWarningTriangleFilled, { className: "text-white w-5 h-5" }), "Deactivate Link"] }), _jsx("button", { className: "text-blue-600 font-medium hover:text-blue-800", "data-test": "deactivate-link-cancel-button", onClick: onClose, children: "Cancel" })] })] })] }) }));
};
export default DeactivateLinkModal;
